<a [href]="href" [target]="target" class="ds-ui-2">
  <app-ds-icon *ngIf="icon" [name]="icon" [color]="iconColorList[variant]"></app-ds-icon>
  <ng-content></ng-content>
</a>
